import Splide from "@splidejs/splide";

import * as EventListener from "../common/helpers/event-listener";
import csrfToken from "../common/helpers/csrf-token";

const init = () => {
    const splideBlock = document.getElementById("product_images");
    const products = document.getElementById("products_similar");

    if (splideBlock) {
        slider();
    }

    if (products) {
        productsSlider();
    }
};

const changeOffer = () => {
    EventListener.change("change-offer-option", (element) => {
        document.querySelectorAll(".change-offer-option").forEach((element) => {
            element.disabled = true;
        });

        oc.ajax("Settings::onAjax", {
            data: {
                _token: csrfToken,
                offer_id: element.value,
            },
            loading: "#loader-line",
            update: {
                "catalog/product-page/product": ".product-wrapper",
                "catalog/product-page/rating-reviews":
                    ".reviews-and-rating-wrapper",
                "gtm/product-details": "@body",
                "gtm/add-product-to-cart": ".add-product-to-cart-wrapper",
            },
            complete: () => {
                slider();
                element.disabled = false;
                document
                    .querySelectorAll(".change-offer-option")
                    .forEach((element) => {
                        element.disabled = false;
                    });
            },
        });
    });
};

const slider = () => {
    new Splide("#product_images", {
        arrows: false,
        pagination: true,
    }).mount();
};

const productsSlider = () => {
    new Splide("#products_similar", {
        autoWidth: true,
        omitEnd: true,
        focus: 0,
        gap: 0,
        arrows: false,
        mediaQuery: "min",
        breakpoints: {
            961: {
                destroy: true,
            },
        },
    }).mount();
};

const addToWishList = () => {
    EventListener.click("product-button-wishlist", (button) => {
        if (button.classList.contains("active")) {
            return;
        }

        const productId = button.getAttribute("data-product-id");

        oc.ajax("WishList::onAdd", {
            data: {
                _token: csrfToken,
                product_id: productId,
            },
            loading: "#loader-line",
            complete: (result) => {
                if (result.status) {
                    document
                        .querySelectorAll(
                            `.product-button-wishlist[data-product-id="${productId}"]`,
                        )
                        .forEach((element) => {
                            element.classList.add("active");
                        });

                    button.classList.add("active");
                }

                button.disabled = false;
            },
        });
    });
};

const removeFromWishList = () => {
    EventListener.click("product-button-wishlist", (button) => {
        if (!button.classList.contains("active")) {
            return;
        }

        const productId = button.getAttribute("data-product-id");

        oc.ajax("WishList::onRemove", {
            data: {
                _token: csrfToken,
                product_id: productId,
            },
            loading: "#loader-line",
            complete: (result) => {
                if (result.status) {
                    button.classList.remove("active");

                    document
                        .querySelectorAll(
                            `.product-button-wishlist[data-product-id="${productId}"]`,
                        )
                        .forEach((element) => {
                            element.classList.remove("active");
                        });
                }

                button.disabled = false;
            },
        });
    });
};

const openGifts = () => {
    EventListener.click("product-gifts-button", (button) => {
        const blockClass = "product-gifts";
        const hiddenClass = "open";

        if (button.parentElement.classList.contains(hiddenClass)) {
            button.parentElement.classList.remove(hiddenClass);
            document.removeEventListener("click", clickGiftOutside);
        } else {
            button.parentElement.classList.add(hiddenClass);
            document.addEventListener("click", clickGiftOutside);
        }

        const openedBlock = document.querySelector(
            "." + blockClass + "." + hiddenClass,
        );

        document
            .querySelectorAll("." + blockClass + "." + hiddenClass)
            .forEach((opened) => {
                if (opened !== openedBlock) {
                    opened.classList.remove(hiddenClass);
                }
            });

        button.disabled = false;
    });
};

const clickGiftOutside = (event) => {
    const blockClass = "product-gifts";
    const hiddenClass = "open";

    const block = document.querySelector("." + blockClass + "." + hiddenClass);

    if (block) {
        if (!block.contains(event.target)) {
            block.classList.remove(hiddenClass);
            document.removeEventListener("click", clickGiftOutside);
        }
    }
};

const changeNumberOfOffer = () => {
    const disableButtons = (disabled) => {
        document
            .querySelectorAll(".add-one-offer-button")
            .forEach((element) => {
                element.disabled = disabled;
            });

        document
            .querySelectorAll(".remove-one-offer-button")
            .forEach((element) => {
                element.disabled = disabled;
            });
    };

    const updateNumberOfOffer = (button, value) => {
        disableButtons(true);

        const offerCountId = button.getAttribute("data-offer-count-id");
        const numberOfOfferInput = document.getElementById(offerCountId);

        if (numberOfOfferInput) {
            let count = numberOfOfferInput.value.trim();
            count = Number(count);
            count = !count || count < 0 ? 1 : count;
            count = count + value;
            count = !count ? 1 : count;
            count = count > 10 ? 10 : count;

            numberOfOfferInput.value = count;
        }

        disableButtons(false);
        button.disabled = false;
    };

    EventListener.click("add-one-offer-button", (button) => {
        updateNumberOfOffer(button, +1);
    });

    EventListener.click("remove-one-offer-button", (button) => {
        updateNumberOfOffer(button, -1);
    });
};

const clickContentTab = () => {
    EventListener.click("data-tab-toggle", (button) => {
        const openClass = "tab-open";

        if (window.innerWidth > 961) {
            return;
        }

        if (button.parentNode.classList.contains(openClass)) {
            button.parentNode.classList.remove(openClass);
        } else {
            button.parentNode.classList.add(openClass);
        }
    });
};

const clickOnProduct = () => {
    document.addEventListener("click", (event) => {
        let element = event.target;

        if (!element.classList.contains("click-on-product")) {
            element = element.closest(".click-on-product");

            if (!element) {
                return;
            }
        }

        try {
            if (!isDataLayer || !isGa) {
                return;
            }

            const listElement = document.getElementById(
                "catalog_eec_impressionView",
            );

            if (!listElement) {
                return;
            }

            const listElementData = JSON.parse(listElement.innerHTML);

            if (!listElementData) {
                return;
            }

            const offerId = element.getAttribute("data-offer-id");
            const offerData = listElementData.find(
                (item) => item.id === offerId,
            );

            if (!offerData) {
                return;
            }

            if (isDataLayer) {
                dataLayer.push({
                    event: "eec.impressionClick",
                    ecommerce: {
                        click: {
                            actionField: {
                                list: offerData.list,
                            },
                            products: [
                                {
                                    id: offerData.id,
                                    name: offerData.name,
                                    category: offerData.category,
                                    position: offerData.position,
                                },
                            ],
                        },
                    },
                });
            }

            if (isGa) {
                ga("ec:addProduct", {
                    id: offerData.id,
                    name: offerData.name,
                    category: offerData.category,
                    brand: "Floridelux",
                    variant: "",
                    position: offerData.position,
                });

                ga("ec:setAction", "click", { list: offerData.list });

                ga("send", "event", "UX", "click", "Results", {});
            }
        } catch (error) {}
    });
};

init();
changeOffer();
addToWishList();
removeFromWishList();
openGifts();
changeNumberOfOffer();
clickContentTab();
clickOnProduct();
